import React from 'react';
import PropTypes from 'prop-types';
import store from 'src/store';

import {
  Grid, Button, Avatar, List, ListItem, ListItemText, IconButton, Popover
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import AccountCircle from '@material-ui/icons/AccountCircle';
import SettingsIcon from '@material-ui/icons/Settings';

import { Translate } from 'src/translations/i18n';

import SuperRightsCheckbox from 'src/components/UserCabinet/SuperRightsCheckbox';
import { setLoggingOut } from 'src/store/actions/userActions';
import userManager from 'src/auth/userManager';
import { getEntity } from 'src/components/EntityInspector/EntityEntryPointHelper';
import Inspectable from 'src/components/EntityInspector/Inspectable/Inspectable';
import packageJson from '../../../package.json';
import conf from '../../conf/conf';

import ektacoLogo from '../../images/ektaco.svg';
import logos from '../../images/logos.jpg';


import LangSelect from './LangSelect';
import ThemeSelect from './ThemeSelect';

import CompaniesSelector from '../CompaniesSelector';

const styles = (theme) => ({
  userName: {
    color: 'white',
    textTransform: 'none',
    display: '-webkit-box'
  },
  userRole: {
    textTransform: 'none',
    color: '#FFF'
  },
  container: {
    overflow: 'visible',
    margin: '0!important',
    width: '100%!important',
    outline: 'none',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      flexFlow: 'column wrap!important'
    }
  },
  logoItem: {
    height: 35,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  section: {
    borderLeft: '1px solid gray',
    '&:first-of-type': {
      borderLeft: 'none'
    },
    [theme.breakpoints.down('md')]: {
      borderLeft: 'none!important',
      borderBottom: '1px solid gray!important',
      width: '100%!important',
      maxWidth: '100%!important',

      '&:last-of-type': {
        borderBottom: 'none!important'
      }
    },
    '& p': {
      marginBottom: '0.6em'
    }
  },
  centredSection: {
    textAlign: 'center'
  },
  companyName: {
    textAlign: 'left',
    margin: '0 !important'
  },
  logout: {
    marginTop: theme.spacing(2)
  },
  imageLink: {
    width: '-webkit-fill-available',
    textAlign: 'center',
    padding: theme.spacing(1)
  },
  ektacoLogo: {
    width: 150,
    height: 'auto'
  },
  easLogo: {
    width: 150,
    height: 'auto'
  },
  supportMail: {
    color: '#1890ff'
  },
  companyChanger: {
    width: '100% !important'
  },
  paper: {
    overflow: 'visible',
    maxHeight: 'calc(100% - 32px)'
  },
  multiline: {
    margin: 0,
    paddingLeft: theme.spacing(0.5)
  },
  listItem: {
    padding: 0,
    '&:hover': {
      background: 'inherit'
    }
  },
  list: {
    padding: 0,
    minWidth: 160
  },
  settingsButton: {
    color: '#FFF',
    width: 48,
    height: 48,
    margin: 8
  }
});

class UserCabinet extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      anchor: null,
      companiesIds: []
    };

    try {
      this.channel = new BroadcastChannel('ccOfficeSessionChannel');
      this.channel.onmessage = (event) => {
        if (`${event.data}` !== `${props.userInfo.CompanyId}`) {
          window.location.reload();
        }
      };
    } catch (error) {
      console.error(error);
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.userInfo && props.userInfo.CompanyId && !state.companiesIds.length) {
      return {
        ...state,
        companiesIds: [props.userInfo.CompanyId]
      };
    } else {
      return state;
    }
  }

  // eslint-disable-next-line react/state-in-constructor
  state = {
    anchor: null,
    companiesIds: []
  };

  onOpen = (anchor) => this.setState({ anchor });

  onClose = () => this.setState({ anchor: null });

  renderUserButton = () => {
    const { userInfo, user, classes } = this.props;
    const { anchor } = this.state;
    const { ProfilePictureThumbnailUrl } = userInfo;

    let userName = 'Jon Doe';
    let group = '';

    if (userInfo && userInfo.UserName) {
      userName = userInfo.UserName;
    } else if (user) {
      userName = user;
    }

    if (userInfo.UserGroupWithRights && userInfo.UserGroupWithRights.Name) {
      group = userInfo.UserGroupWithRights.Name;
    }

    const renderUserInfo = () => {
      let userEntity = {};
      let userGroupEntity = {};
      if (userInfo.UserId) {
        userEntity = getEntity.user(userInfo.UserId);
        userGroupEntity = getEntity.userGroup(userInfo.UserGroupWithRights.Id);
      }
      return (
        <div className={classes.multiline}>
          <div className={`${classes.userName} line-clamp-ellipsis`}>
            <Inspectable entity={userEntity}>{userName}</Inspectable>
          </div>
          <div className={`${classes.userRole} line-clamp-ellipsis`}>
            <Inspectable entity={userGroupEntity}>{group}</Inspectable>
          </div>
        </div>
      );
    };

    const avatarUrl = ProfilePictureThumbnailUrl && `${conf.api}${ProfilePictureThumbnailUrl}`;

    return (
      <Button
        aria-owns={anchor ? 'user-cabinet' : undefined}
        aria-haspopup="true"
        onClick={(event) => this.onOpen(event.currentTarget)}
      >
        <List className={classes.list}>
          <ListItem className={classes.listItem}>
            <Avatar>
              {avatarUrl
                ? <img src={avatarUrl} alt="profile" />
                : <AccountCircle style={{ fontSize: 40 }} />}
            </Avatar>
            {renderUserInfo()}
          </ListItem>
        </List>
      </Button>
    );
  };

  logout = () => {
    userManager.signoutRedirect();
    store.dispatch(setLoggingOut(true));
  };

  renderUserCompanies = () => {
    const { userInfo, classes } = this.props;
    const { CompanyName, Companies, CompanyId } = userInfo;

    return (
      <>
        <p style={{ marginTop: '14px' }}>
          <Translate value="Company" />
          {' '}
          :
        </p>
        <div className={classes.centredSection}>
          {Companies && Companies.length > 1
            ? <CompaniesSelector options={Companies} className={classes.companyChanger} companyId={`${CompanyId}`} />
            : <p className={classes.companyName}>{CompanyName}</p>}
          {userInfo.IsEktacoUser && <SuperRightsCheckbox />}
          <Button
            onClick={this.logout}
            variant="contained"
            color="primary"
            className={classes.logout}
          >
            <Translate value="Logout" />
          </Button>
        </div>
      </>
    );
  };

  render() {
    const {
      userInfo, versions, handleChangeOfLang, selectedLang, classes, changeTheme, themeType
    } = this.props;
    const { anchor } = this.state;

    return (
      <>
        {userInfo
          ? this.renderUserButton()
          : (
            <IconButton onClick={(event) => this.onOpen(event.currentTarget)} className={classes.settingsButton}>
              <SettingsIcon />
            </IconButton>
          )}
        <Popover
          id="user-cabinet"
          anchorEl={anchor}
          open={!!anchor}
          onClose={this.onClose}
          classes={{
            paper: classes.paper
          }}
        >
          <Grid
            container
            wrap="nowrap"
            spacing={2}
            className={classes.container}
          >
            <Grid item xs={4} className={classes.section}>
              <p>
                <Translate value="Language" />
                {' '}
                :
              </p>
              <LangSelect
                handleChangeOfLang={handleChangeOfLang}
                selectedLang={selectedLang}
              />
              {!!userInfo && this.renderUserCompanies()}
            </Grid>

            <Grid item xs={4} className={classes.section}>
              <p>
                <Translate value="Theme" />
                {' '}
                :
              </p>
              <ThemeSelect
                changeTheme={changeTheme}
                themeType={themeType}
              />
            </Grid>

            <Grid item xs={3} className={classes.section}>
              <p>
                <Translate value="Version" />
                {' '}
                :
              </p>
              <p>
                Web:
                {packageJson.version}
              </p>
              <p>
                API:
                {versions.ApiVersion}
              </p>
              <p>
                DB:
                {versions.DatabaseVersion}
              </p>
            </Grid>
            <Grid item xs={5} className={`${classes.section} ${classes.centredSection}`}>
              <Grid
                container
                direction="column"
                spacing={1}
                className={classes.container}
              >
                <Grid item className={classes.logoItem}>
                  <a
                    className={classes.imageLink}
                    href="http://www.ektaco.ee/labipaasud/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={ektacoLogo}
                      alt="logo"
                      className={classes.ektacoLogo} />
                  </a>
                </Grid>
                <Grid item>
                  <a
                    className={classes.imageLink}
                    href="http://www.ektaco.ee/kassasusteemid/eas/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={logos}
                      alt="logo"
                      className={classes.easLogo} />
                  </a>
                </Grid>
                <Grid item>
                  <a
                    href="mailto:compuaccess@ektaco.ee"
                    className={classes.supportMail}
                  >
                    compuaccess@ektaco.ee
                  </a>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Popover>
      </>
    );
  }
}

UserCabinet.propTypes = {
  user: PropTypes.string,
  userInfo: PropTypes.object,
  versions: PropTypes.object,
  selectedLang: PropTypes.string.isRequired,
  handleChangeOfLang: PropTypes.func.isRequired,
  classes: PropTypes.object,
  changeTheme: PropTypes.func.isRequired,
  themeType: PropTypes.string.isRequired
};

UserCabinet.defaultProps = {
  user: null,
  userInfo: null,
  versions: null,
  classes: {}
};

export default withStyles(styles)(UserCabinet);
